import { FormProvider, useWatch } from 'react-hook-form';
import { FormInput } from '@/components/form/form-input';
import { groupSizeLabel } from '@/features/inventory/activity-pricing.utils';
import { SmartSuggestionFormShell } from '@/features/inventory/pages/smart-suggestion/form-shell';
import { useGroupSizePresetForm } from '../../hooks/price-preset-hooks';
import { amountInputProps } from '../price-presets/amount-input-props';

const GroupSizePresetForm = () => {
  const { id, form, isLoading, isSaving, handleReset, handleDelete, onSubmit } =
    useGroupSizePresetForm();

  const [min, max] = useWatch({
    control: form.control,
    name: ['minParticipant', 'maxParticipant'],
  });
  const rangeLabel = groupSizeLabel(min, max);

  return (
    <div className="space-y-6">
      <FormProvider {...form}>
        <SmartSuggestionFormShell
          id={id}
          title={id ? 'Edit Group Size' : 'New Group Size'}
          description="Leave To empty for no upper limit. Without a label the picker shows the range. Default Amount is pre-filled when the tier is added to an activity: minus for a discount (-3), plain for a surcharge. Active group sizes may not overlap."
          isLoading={isLoading}
          isSaving={isSaving}
          onSubmit={form.handleSubmit(onSubmit)}
          onReset={handleReset}
          onDelete={handleDelete}
        >
          <FormInput
            name="minParticipant"
            label="From"
            type="number"
            min={1}
            step={1}
            placeholder="1"
            required
          />
          <FormInput
            name="maxParticipant"
            label="To"
            type="number"
            min={1}
            step={1}
            placeholder="No limit"
            optional
          />
          <FormInput
            name="label"
            label="Label"
            placeholder={rangeLabel || 'e.g. 1-4 participants'}
            optional
          />
          <FormInput
            name="defaultAmount"
            label="Default Amount"
            {...amountInputProps}
          />
        </SmartSuggestionFormShell>
      </FormProvider>
    </div>
  );
};

export default GroupSizePresetForm;
